import { render } from "./AdminWithdrawal.vue?vue&type=template&id=c49d10de&scoped=true"
import script from "./AdminWithdrawal.vue?vue&type=script&lang=js"
export * from "./AdminWithdrawal.vue?vue&type=script&lang=js"

import "./AdminWithdrawal.vue?vue&type=style&index=0&id=c49d10de&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c49d10de"]])

export default __exports__